<template>
  <div>
    <section class="information-line">
      <h2 class="information-line__ttl">{{message}}</h2>
    </section>
  </div>
</template>

<script>
  export default {
    props: ["message"],
    data() {
      return {

      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/TopInformation.vue